/* eslint-disable no-plusplus */

/* eslint-disable no-param-reassign */

/**
 * CSS Grid during pan
 *
 * Determine the next Grid values for a dimension
 * (rows or columns) given a Grid definition and
 * pan values.
 */
export function getNextGridSizesDuringPan(currentIndex, pan, state) {
  var units = state.units; // moving up

  if (pan < 0) {
    var nextExpandedIndex = units.slice(currentIndex + 1).findIndex(function (unit) {
      return unit.isShowing;
    }) + currentIndex + 1;
    var remainder = Math.abs(pan);
    var nextExpandedPanel = units[nextExpandedIndex];

    if (nextExpandedPanel.max) {
      var startSize = nextExpandedPanel.snapshot;
      var potentialNextSize = startSize + remainder;

      if (potentialNextSize > nextExpandedPanel.max) {
        remainder = nextExpandedPanel.max - startSize;
      }
    }

    for (var index = currentIndex; index >= 0; index -= 1) {
      var _units$index = units[index],
          min = _units$index.min,
          _max = _units$index.max,
          _snapshot = _units$index.snapshot,
          isShowing = _units$index.isShowing;
      var prevSize = _snapshot - remainder;
      var minSize = isShowing ? min : 0;

      if (prevSize <= minSize) {
        prevSize = minSize;
      }

      if (_max && prevSize >= _max) {
        prevSize = _max;
      }

      var diffSize = _snapshot - prevSize;
      remainder -= diffSize;
      units[index].size = prevSize;
    }

    var snapshot = nextExpandedPanel.snapshot,
        max = nextExpandedPanel.max;
    var nextSize = snapshot - pan - remainder;

    if (max && nextSize > max) {
      remainder += nextSize - max;
      nextSize = max;
    }

    nextExpandedPanel.size = nextSize;
    return remainder * -1;
  } // moving down


  if (pan > 0) {
    var _remainder = pan;
    var prevExpandedIndex = currentIndex;
    var prevExpandedPanel = units[prevExpandedIndex];

    if (prevExpandedPanel.max) {
      var _startSize = prevExpandedPanel.snapshot;

      var _potentialNextSize = _startSize + _remainder;

      if (_potentialNextSize > prevExpandedPanel.max) {
        _remainder = prevExpandedPanel.max - _startSize;
      }
    }

    for (var _index = currentIndex + 1; _index <= units.length - 1; _index += 1) {
      var panel = units[_index];
      var _min = panel.min,
          _snapshot3 = panel.snapshot,
          _isShowing = panel.isShowing;

      var _nextSize2 = _snapshot3 - _remainder;

      var _minSize = _isShowing ? _min : 0;

      if (_nextSize2 <= _minSize) {
        _nextSize2 = _minSize;
      }

      var diffHeight = _snapshot3 - _nextSize2;
      _remainder -= diffHeight;
      panel.size = _nextSize2;
    }

    var _snapshot2 = prevExpandedPanel.snapshot,
        _max2 = prevExpandedPanel.max;

    var _nextSize = _snapshot2 + pan - _remainder;

    if (_max2 && _nextSize > _max2) {
      _remainder += _nextSize - _max2;
      _nextSize = _max2;
    }

    prevExpandedPanel.size = _nextSize;
    return _remainder;
  }

  return 0;
}
/**
 * Transform panel helper
 *
 * Given units with a snapshot + size value, determine
 * the scales and translate values needed to replicate
 * the in-flight resize.
 */

export function transformPanelDuringResize(units, unitIndexes) {
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var offsetBeforeResize = 0;
  var offsetAfterResize = 0;
  var offsetIndex = unitIndexes.values().next().value;
  units.some(function (unit, i) {
    if (i === offsetIndex) {
      return true;
    }

    offsetBeforeResize += unit.snapshot;
    offsetAfterResize += unit.size;
    return false;
  });
  var offset = offsetAfterResize - offsetBeforeResize;
  var sizeBeforeResize = 0;
  var sizeAfterResize = 0;
  unitIndexes.forEach(function (index) {
    var _units$index2 = units[index],
        snapshot = _units$index2.snapshot,
        size = _units$index2.size;
    sizeBeforeResize += snapshot;
    sizeAfterResize += size;
  }); // If an element 0 width, we retain its existing scale

  var scale = sizeBeforeResize === 0 || sizeAfterResize === 0 ? 1 : (roundToThreeDigets(sizeAfterResize) - padding * 2) / (roundToThreeDigets(sizeBeforeResize) - padding * 2);
  return {
    scale: scale,
    offset: offset,
    sizeBeforeResize: sizeBeforeResize,
    sizeAfterResize: sizeAfterResize
  };
}

function roundToThreeDigets(x) {
  return Math.round(x * 100) / 100;
} //


export function determineSizeUponToggle(units, containerSize) {
  var size = containerSize;
  var flexIndexes = []; // let customSizedFlexPanel = null;

  units.forEach(function (u, i) {
    if (u.isFlex && u.isShowing) {
      // if (u.useCustomSize) {
      //   customSizedFlexPanel = i;
      // }
      flexIndexes.push(i);
    }

    if (!u.isFlex && u.isShowing) {
      size -= u.size;
    }
  }); // const indexSizes = {};
  // if (customSizedFlexPanel != null) {
  //   flexIndexes.forEach((i) => {
  //     indexSizes[i] = units[i].size / size;
  //   });
  //   if (flexIndexes.length === 1) {
  //     units[customSizedFlexPanel].useCustomSize = false;
  //   }
  // }
  // if using a custom size -> single flex, no longer
  // use custom size.
  // if using custom size, and multiple still open,
  // calculate the ratiod size of both.

  flexIndexes.forEach(function (i) {
    var unit = units[i];
    var nextFlexSize = // customSizedFlexPanel !== null && flexIndexes.length > 1
    //   ? size * indexSizes[i]
    size / flexIndexes.length; // if our flex is going to be smaller
    // than its minimum, we need to shink
    // other panels.

    if (nextFlexSize < unit.min) {
      var remainder = unit.min - nextFlexSize;
      nextFlexSize = unit.min;
      units.forEach(function (u) {
        if (!u.isFlex && remainder && u.isShowing) {
          var nextSize = u.size - remainder;

          if (nextSize < u.min) {
            nextSize = u.min;
          }

          var diffHeight = u.size - nextSize;
          remainder -= diffHeight;
          u.size = nextSize;
        }
      });
    }

    unit.size = nextFlexSize;
  });
}
/**
 * Determine grid-span equivalent css values for each
 * area in a grid-template-areas definitions.
 */

export function getGridSpanValuesFromAreas(areas) {
  var cols = {};
  var rows = {};
  areas.forEach(function (row, rowIndex) {
    row.forEach(function (name, colIndex) {
      var _cols$name, _rows$name;

      cols[name] = (_cols$name = cols[name]) !== null && _cols$name !== void 0 ? _cols$name : new Set();
      rows[name] = (_rows$name = rows[name]) !== null && _rows$name !== void 0 ? _rows$name : new Set();
      cols[name].add(colIndex);
      rows[name].add(rowIndex);
    });
  });
  return {
    cols: cols,
    rows: rows
  };
}
export function getGridSpanForArea(areas, area) {
  var _getGridSpanValuesFro = getGridSpanValuesFromAreas(areas),
      cols = _getGridSpanValuesFro.cols,
      rows = _getGridSpanValuesFro.rows;

  return {
    columns: cols[area],
    rows: rows[area]
  };
}
/**
 * Determine if we should render a resizer.
 */

export function shouldRenderResizer(area, template, resizer) {
  if (!resizer) {
    return false;
  }

  var resizerAtEnd = isResizerAtEnd(resizer);

  switch (resizer) {
    case 'left':
      return !isFirstVisibleUnit(getAreaColumn(area, template.areas, resizerAtEnd), template.columns);

    case 'right':
      return !isLastVisibleUnit(getAreaColumn(area, template.areas, resizerAtEnd), template.columns);

    case 'top':
      return !isFirstVisibleUnit(getAreaRow(area, template.areas, resizerAtEnd), template.rows);

    case 'bottom':
      return !isLastVisibleUnit(getAreaRow(area, template.areas, resizerAtEnd), template.rows);

    default:
      return false;
  }
}
export function isFirstVisibleUnit(firstIndex, units) {
  for (var i = firstIndex - 1; i >= 0; i--) {
    var column = units[i];

    if (column.showing || typeof column.showing === 'undefined') {
      return false;
    }
  }

  return true;
}

function isLastVisibleUnit(lastIndex, units) {
  for (var i = lastIndex + 1; i < units.length; i++) {
    var column = units[i];

    if (column.showing || typeof column.showing === 'undefined') {
      return false;
    }
  }

  return true;
}
/**
 * Determine which column an area belongs to.
 * @param area string
 * @param areas Array<Array<string>>
 * @param resizerAtEnd boolean
 */


export function getAreaColumn(area, areas, resizerAtEnd) {
  var index = null;
  areas.some(function (row) {
    return row.some(function (column, i) {
      if (column === area) {
        index = i;
        return true;
      }

      return false;
    });
  });

  if (index === null) {
    throw new Error("Unable to find the column index for ".concat(area));
  }

  if (!resizerAtEnd) {
    index -= 1;
  }

  return index;
}
/**
 * Determine which row an area belongs to.
 * @param area string
 * @param areas Array<Array<string>>
 * @param resizerAtEnd boolean
 */

export function getAreaRow(area, areas, resizerAtEnd) {
  var index = null;
  areas.some(function (row, i) {
    var isInRow = row.some(function (column) {
      return column === area;
    });

    if (isInRow) {
      index = i;
      return true;
    }

    return false;
  });

  if (index === null) {
    throw new Error("Unable to find the column index for ".concat(area));
  }

  if (!resizerAtEnd) {
    index -= 1;
  }

  return index;
}
export function isResizerAtEnd(resizer) {
  return resizer === 'right' || resizer === 'bottom';
}